<template>
  <div class="lxm-cf-project-feedback-detail">
    <!--<lxm-nav :title="'羊宝宝和小兔兔的展览筹款'" :share="true"></lxm-nav>-->

    <div class="page">

      <div v-if="privateForm === ''">
        
      </div>
      <div v-else-if="privateForm">
        <h2 class="subtitle">反馈详情</h2>
        <p class="private_form">该表单为“私密表单”，请联系表单创建人申请权限查看反馈详情</p>
      </div>
      <div v-else>
        <h2 class="subtitle">反馈详情 {{ state.index }}/{{ state.count }}</h2>
        <transition name="lxm-content-transition" mode="out-in">
          <div v-if="!loading">
            <template v-for="row in rows">
              <lxm-form-row :row="row"></lxm-form-row>
            </template>
          </div>
        </transition>
      </div>

    </div>
    <!--<lxm-prev-next></lxm-prev-next>-->
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/variables.styl'
  .private_form {
    font-size: 24px;
    color: red;
    font-weight: bold;
    text-align: center;
    margin-top: 10rem;
  }
</style>

<script>
  import LxmNav from '../common/LxmNav.vue'
  import LxmFormRow from '../common/LxmFormRow.vue'
  import LxmPrevNext from '../common/LxmPrevNext.vue'
  import * as aTypes from '../../../store/action-types'
  export default {
    components: {
      LxmNav,
      LxmFormRow,
      LxmPrevNext
    },
    computed: {
      loading () {
        return this.$store.state.loading[aTypes.FORM_GET_FEEDBACK_DETAIL]
      },
      state () {
        return this.$store.state.form.feedbackDetail
      },
      rows () {
        if (this.$store.state.loading[aTypes.FORM_GET_FEEDBACK_DETAIL]) {
          return []
        } else {
          return this.state.rows
        }
      },
      privateForm () {
        return this.state.privateForm
      }
    },
    mounted () {
      this.getData()
    },
    watch: {
      $route () {
        this.getData()
      }
    },
    methods: {
      getData () {
        this.$store.dispatch(aTypes.FORM_GET_FEEDBACK_DETAIL, {
          contactId: this.$route.query.contactId,
          formId: this.$route.query.formId,
          formfillId: this.$route.query.formfillId
        })
        this.$store.dispatch(aTypes.ZHUGE_TRACK, { event: '到达表单反馈详情页' })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FeedbackDetail.vue?07d881fc